import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';//use this to get value from nest object

@Pipe({
  name: 'rdsFilterFields'
})
export class RdsFilterFieldsPipe implements PipeTransform {

  transform(lstRecords: any[], lstFieldNames: string[], searchVal: any): any {
		return lstRecords.filter(record => this.validation(record, lstFieldNames, searchVal));
	}

	validation(record: any, fieldnames: string[], searchVal: any) {
		if (!searchVal) return true;

		let isValid = false;
		//to make sure search value become string
		let searchTxt:string = searchVal + '';

		fieldnames.forEach(fieldname => {
			let fieldValue = get(record, fieldname) + ''; //+ '' because to make sure value is text
			
			fieldValue = !fieldValue ? '' : fieldValue.toLowerCase();

			if (fieldValue.indexOf(searchTxt.toLowerCase()) > -1) {
				isValid = true;
			}
		});

		return isValid;
	}

}
